export const corePlans = [
  { prod: "free_plan", prodid: "prod_NW8VsQjkX8SDeI" },
  { prod: "basic_plan", prodid: "prod_KWc6wcdgO14YuZ" },
  { prod: "plus_plan", prodid: "prod_KWc6gkWGJpLZqg" },
  { prod: "core_plan", prodid: "prod_KWc61wzis98e3M" },
  { prod: "pro_plan", prodid: "prod_KWc7UdwUfC8P6A" },
  { prod: "master_plan", prodid: "prod_KWc7PksDHVehC6" },
];
export const addons = [
  { prod: "sector_dashboard", prodid: "prod_KWc7iRzUKfTT3n" },
  { prod: "currency_dashboard", prodid: "prod_KWc7M8w4sbyBi4" },
  { prod: "income_dashboard", prodid: "prod_KWc7ozyM958jSR" },
  { prod: "equity_dashboard", prodid: "prod_KWc7yMCnE6ExmS" },
  { prod: "commodity_dashboard", prodid: "prod_KWc7vyItUXZmMY" },
  { prod: "crypto_dashboard", prodid: "prod_KWc8ne1jAPTSxu" },
  { prod: "macro_dashboard", prodid: "prod_KkiPKN9FM8QPW6" },
  { prod: "signal_alerts", prodid: "prod_KWc8kyRaRmvS9r" },
];
